<template>
    <DForm
        @submit.prevent="submitForm"
    >
        <div class="my-antagonist-form">
            <DCard
                :title="__('settings.my_antagonist.title')"
                class="mb-4"
                padding
            >
                <DFormRow
                    :label="__('settings.my_antagonist.form.url')"
                    is-required
                    :error="errorsData.api_url"
                    :hint="__('settings.my_antagonist.form.url_hint')"
                >
                    <DInput
                        id="api_url"
                        v-model="form.api_url"
                        :placeholder="__('settings.my_antagonist.form.url')"
                        :is-valid="isFormFieldValid('api_url')"
                        maxlength="128"
                        @update:value="valueUpdated"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.my_antagonist.form.username')"
                    is-required
                    :error="errorsData.api_username"
                    :hint="__('settings.my_antagonist.form.username_hint')"
                >
                    <DInput
                        id="api_username"
                        v-model="form.api_username"
                        :placeholder="__('settings.my_antagonist.form.username')"
                        :is-valid="isFormFieldValid('api_username')"
                        maxlength="128"
                        @update:value="valueUpdated"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.my_antagonist.form.password')"
                    is-required
                    :error="errorsData.api_password"
                    :hint="__('settings.my_antagonist.form.password_hint')"
                >
                    <DInput
                        id="api_password"
                        v-model="form.api_password"
                        type="password"
                        :placeholder="__('settings.my_antagonist.form.password')"
                        :is-valid="isFormFieldValid('api_password')"
                        maxlength="255"
                        @update:value="valueUpdated"
                    />
                </DFormRow>
                <DRow>
                    <DCol sm="4" />
                    <DCol sm="4">
                        <div
                            v-show="connectionStatus === 'successful'"
                            class="green-text"
                        >
                            {{ __('settings.connections.connection_successful') }}
                        </div>
                        <div
                            v-show="connectionStatus === 'unsuccessful'"
                            class="red-text"
                        >
                            {{ __('settings.connections.connection_unsuccessful') }}
                        </div>
                    </DCol>
                    <DCol
                        sm="4"
                        class="check-database-connection-btn"
                    >
                        <DButton
                            icon="lan-connect"
                            :label="__('settings.connections.check_connection')"
                            :disabled="isInLoadingState"
                            @click="checkConnection"
                        />
                    </DCol>
                </DRow>
            </DCard>
        </div>
        <DFormControls
            :dirty="form.isDirty"
            :disabled="connectionStatus !== 'successful'"
            @submit="submitForm"
        />
        <DConnectionErrorModal
            :show-modal="connectionException !== null"
            :exception="connectionException"
            @close-modal="closeErrorCheckModal"
        />
    </DForm>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { ref } from 'vue'

import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'

const props = defineProps({
    myAntagonistSettings: {
        type: Array,
        default: () => { return [] }
    },
    errors: {
        type: Object,
        default: () => ({})
    }
})

const connectionStatus = ref(null)
const errorsData = ref(props.errors)
const connectionException = ref(null)

const emit = defineEmits(['form-submitted'])

const form = useForm({
    api_url: props.myAntagonistSettings?.api_url ?? null,
    api_username: props.myAntagonistSettings?.api_username ?? null,
    api_password: props.myAntagonistSettings?.api_password ?? null
})

const checkConnection = function () {
    errorsData.value = {}
    connectionException.value = null
    window.axios.post(route('settings.my-antagonist-settings.check-connection'), form)
        .then(function () {
            connectionStatus.value = 'successful'
        })
        .catch(function (error) {
            connectionStatus.value = 'unsuccessful'

            if (error.response.data.errors !== undefined) {
                errorsData.value = error.response.data.errors

                for (const key in errorsData.value) {
                    if (typeof errorsData.value[key] === 'object') {
                        errorsData.value[key] = errorsData.value[key][0]
                    }
                }
            }
            if (error?.response.data.exception !== undefined) {
                connectionException.value = error.response.data.exception
            }
        })
}

const submitForm = () => {
    emit('form-submitted', form)
}

const valueUpdated = () => {
    connectionStatus.value = null
}
const closeErrorCheckModal = () => {
    connectionException.value = null
}
</script>

<style scoped lang="scss">

.check-database-connection-btn {
    text-align: right;
    padding-bottom: 25px;
}

.green-text {
    color: green;
}
.red-text {
    color: red;
}

</style>
